import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  marginHeader: {
    marginTop: "64px",
  },
  spinnerContainer: {
    flexDirection: "row",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    marginTop: "64px",
  },
  topRestContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: "0px",
    width: "100%",
    paddingBottom: 20,
    marginTop: "64px",
  },
  topRestWrapper: {
    background: "transparent",
    width: "100%",
    minHeight: "auto",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    display: "flex",
    alignItems: "center",
    position: "relative",
    padding: "40px 0",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "20px 0",
    },
  },
}));

export default useStyles;
